import { analyticEvent, inlineErrorEvent, overlayEvent } from './common';

export const unsubscribeFromPostalMail = analyticEvent('marketing preferences: unsubscribe from postal mail button');

const verifyText = 'verify your mailing address';
export const verifyOverlay = overlayEvent(verifyText);
export const verifyOverlayError = inlineErrorEvent(verifyText);

const removeText = 'remove from mailing list';
export const removeOverlay = overlayEvent(removeText);

export const verifyMailingEvent = analyticEvent('verify your mailing address: confirm');

const confirmMailingAddress = 'confirm your mailing address: verified address confirm';
export const confirmVerifiedMailingEvent = analyticEvent(confirmMailingAddress);
export const confirmVerifiedMailingError = inlineErrorEvent(confirmMailingAddress);

const confirmUnverifiedMailingAddress = 'confirm your mailing address: unverified address confirm';
export const confirmUnverifiedMailingEvent = analyticEvent(confirmUnverifiedMailingAddress);
export const confirmUnverifiedMailingError = inlineErrorEvent(confirmUnverifiedMailingAddress);

export const confirmPostalUnsub = analyticEvent('mktg pref:mail list>n');
